import { useTranslation } from '@multaqa/i18n'
import { EditIcon, RotateCcwIcon } from 'lucide-react'
import { type RecordHeaderAction, RecordHeaderActions } from '@/components/record-header-actions'

export function CustomerHeaderActions({
  customerId,
  canEdit,
  canDelete,
  isActive,
  activatePending,
  onDeactivate,
  onActivate,
}: {
  customerId: string
  canEdit: boolean
  canDelete: boolean
  isActive: boolean
  activatePending: boolean
  onDeactivate: () => void
  onActivate: () => void
}) {
  const { t } = useTranslation()
  const actions: RecordHeaderAction[] = [
    {
      id: 'edit',
      label: t('action.edit'),
      icon: EditIcon,
      variant: 'primary',
      primary: true,
      hidden: !canEdit,
      link: { to: '/customers/$customerId/edit', params: { customerId } },
    },
    isActive
      ? {
          id: 'deactivate',
          label: t('customer.deactivate'),
          variant: 'destructive',
          hidden: !canDelete,
          onSelect: onDeactivate,
        }
      : {
          id: 'activate',
          label: t('customer.activate'),
          icon: RotateCcwIcon,
          disabled: activatePending,
          loading: activatePending,
          hidden: !canEdit,
          onSelect: onActivate,
        },
  ]

  return <RecordHeaderActions actions={actions} menuTestId="customer-more-actions" />
}
